<template>
  <div>
    <top></top>
    <div class="my-wrap container" v-loading="loading">
      <titleConfig
        :title="langSet == 'cn' ? '商机详情' : 'Business opportunity details'"
        :type="2"
      ></titleConfig>
      <div class="business_box">
        <div class="top_title">
          <div class="title_picture">
            <img
              v-if="business_detail.member.avatar"
              :src="business_detail.member.avatar"
              alt=""
            />
            <img
              v-if="business_detail.exhibitor_long_id"
              src="@/assets/authentication.png"
              alt=""
            />
          </div>
          <div>
            <div class="title_name">
              <div>{{ business_detail.member.nickname }}</div>
              <div>{{ langSet == 'cn' ? business_detail.member.duties_name : business_detail.member.duties_name_en }}</div>
              <div class="company">
                {{ business_detail.member.companyName }}
              </div>
            </div>
          </div>
        </div>
        <div class="fitter_right">
          <div
            :class="[
              'Collection',
              business_detail.is_collect == 0 ? '' : 'Collection_change',
            ]"
            @click="collect"
          >
            <div>
              {{
                business_detail.is_collect == 0
                  ? langSet == "cn"
                    ? "收藏"
                    : "collect"
                  : langSet == "cn"
                  ? "已收藏"
                  : "Collected"
              }}
            </div>
            <div>|</div>
            <img class="Collection_image" src="@/assets/aixin.png" alt="" />
          </div>
          <div class="response" @click="response_click">
            {{ langSet == "cn" ? "我要应答" : "I need to respond" }}
          </div>
        </div>
        <!--          <div class="see_button">查看详情</div>-->
      </div>
      <div class="content_middle">
        <Content_top
          :title="langSet == 'cn' ? '供应标签' : 'Supply label'"
        ></Content_top>
        <div class="business_label_box">
          <div
            class="business_label"
            v-for="(item, index) in business_detail.label"
            :key="index"
          >
            {{ langSet == "cn" ? item.name : item.name_en }}
          </div>
        </div>

        <Content_top
          :title="langSet == 'cn' ? '需求描述' : 'Requirement'"
        ></Content_top>
        <div class="Requirement_text">
          {{ business_detail.description }}
        </div>
        <div class="for_image" v-if="business_detail.imgs.length > 0">
          <el-image
            class="item_image"
            v-for="(item, index) in business_detail.imgs"
            :key="index"
            :src="item.url"
            @click="amplify(item.url)"
          ></el-image>
        </div>
      </div>
      <template v-if="reply_list_show">
        <div v-if="business_detail.examine == 1">
          <div class="_list_class">
            <Content_top
              :title="langSet == 'cn' ? '应答列表' : 'Response List'"
            ></Content_top>
            <div
              class="list_item"
              v-for="(item, index) in reply_lists"
              :key="index"
            >
              <div class="Personal">
                <div class="Personal_img">
                  <img :src="item.avatar_image" alt="" />
                  <img
                    v-if="item.exhibitor_long_id"
                    src="@/assets/authentication.png"
                    alt=""
                  />
                </div>
                <div class="Personal_f">
                  <div>
                    <div class="flex Personal_text">
                      <div>{{ item.name }}</div>
                      <div>{{ item.duty }}</div>
                    </div>
                    <div>{{ item.company }}</div>
                  </div>
                </div>
              </div>
              <div>{{ item.response_content }}</div>
            </div>
          </div>
          <div class="del_button" @click="business_publish_delete()">
            {{ langSet == "cn" ? "删除需求" : "Delete" }}
          </div>
        </div>
        <div class="shImage" v-if="business_detail.examine == 0">
          <img src="@/assets/shz.png" />
        </div>
        <div class="shImage" v-if="business_detail.examine == 2">
          <img src="@/assets/bh.png" />
        </div>
      </template>
      <div style="margin-bottom: 80px"></div>
    </div>
    <bottom></bottom>
    <template class="amplify_image">
      <el-dialog :visible.sync="amplify_image">
        <img width="100%" :src="amplify_imageUrl" alt="" />
      </el-dialog>
    </template>
    <div class="dialog_box">
      <el-dialog
        v-if="dialogVisible"
        :title="langSet == 'cn' ? '应答' : 'Response'"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div>
          <div class="dialog_line"></div>
          <div class="dialog_box_top">
            <div class="dialog_title_picture">
              <img :src="userInfo.avatar" alt="" />
              <img
                v-if="userInfo.exhibitor_long_id"
                src="@/assets/authentication.png"
                alt=""
              />
            </div>
            <div style="color: #ffffff">
              <div class="dialog_title_name">
                <div>{{ userInfo.nickname }}</div>
                <div>{{ userInfo._duties }}</div>
                <div class="dialog_company">{{ userInfo.companyName }}</div>
              </div>
            </div>
            <!--          <img class="dialog_edit_img" src="@/assets/edit.png" alt=""/>-->
          </div>
          <div class="title_title">
            {{ langSet == "cn" ? "应答留言" : "Reply message" }}
          </div>
          <el-input
            type="textarea"
            :rows="7"
            resize="none"
            :placeholder="
              langSet == 'cn'
                ? '请详细描述您的需求'
                : 'Please provide a detailed description of your requirements'
            "
            v-model="request_content"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="dialog_submit" v-prevent-re-click type="primary" @click="submit">{{
            langSet == "cn" ? "提 交" : "Submit"
          }}</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import top from "@/components/top.vue";
// import topPiece from "@/components/topPiece.vue";
import bottom from "@/components/bottom.vue";
import Select_input_search from "@/components/Select_input_search.vue";
import titleConfig from "@/components/title.vue";
import {
  business_publish_delete,
  business_publish_detail,
  business_publish_lists,
  business_publish_product_cate,
  business_reply_add,
  business_reply_lists,
} from "@/api/business_api";
import Business_list from "@/views/business/component/business_list.vue";
import nodata from "@/components/nodata.vue";
import { collect } from "@/api/api";
import { company_detail } from "@/api/company_api";
import Content_top from "@/components/content_top.vue";
import { MemberConsultation_add } from "@/api/product_api";
import Dialog_release from "@/views/business/component/dialog_release.vue";
import globalMethods from "@/utils/globalMethods";
import router from "@/router";

export default {
  name: "business",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    Content_top,
    titleConfig,
    bottom,
    top,
  },
  data() {
    return {
      langSet: "",
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      flag: localStorage.getItem("Flag") || "",
      item_index: 0,
      search_input: "",
      reply_list_show: false,
      search_options: [],
      dialog_release: false,
      placeholder_select: "筛选",
      placeholder_input: "搜索展商名称或展位号",
      product_category_id: "", //产品类别id
      requirement: "", //描述搜索
      label_value: "1", //筛选项
      businessList: [],
      business_detail: {},
      detail_show: false,
      pageSize: 6,
      pageNo: 1,
      total: 0,
      dialogVisible: false,
      publication_type: "1", //发布类型 1-供应类 2-采购类
      request_content: "",
      loading: false,
      label_list: [
        {
          name: "供应",
          name_en: "supply",
          value: "1",
        },
        {
          name: "需求",
          name_en: "demand",
          value: "2",
        },
        {
          name: "海外采购",
          name_en: "demand",
          value: "3",
        },
      ],
      amplify_image: false,
      amplify_imageUrl: "",
      reply_lists: [],
      metaData: {},
    };
  },
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  async mounted() {
    this.langSet = this.$language;
    let query = this.$route.query;
    // if (query.detail_show) {
    //   this.loading = true;
    //   await this.go_to_detail(query);
    //   if (query.reply_list_show) {
    //     this.reply_list_show = query.reply_list_show;
    //     await this.get_business_reply_lists();
    //   }
    //   this.loading = false;
    // } else {
    //   await this.get_product_cate();
    await this.get_business_publish_detail(query.id);
    // }
  },
  methods: {
    label_change(item, index) {
      if (index + 1 > 0) {
        this.label_value = item.value;
        this.item_index = index;
      }
      this.get_lists();
    },
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async business_publish_delete() {
      const res = await business_publish_delete({
        id: this.business_detail.id,
      });
      this.$router.go(-1);
    },
    query_change(data) {
      this.product_category_id = data.select_value;
      this.page_no = data.pageNo;
      this.requirement = data.search_input;
      this.label_value = data.label_value;
      this.get_lists();
    },

    async get_business_publish_detail(id) {
      const res = await business_publish_detail({ id: id });
      this.business_detail = res.data;
    },
    details_show_change() {
      this.detail_show = !this.detail_show;
      window.scrollTo(0, 0);
    },
    async get_product_cate() {
      const res = await business_publish_product_cate();
      this.search_options = res.data;
    },

    async get_lists() {
      let data = {
        status: this.label_value, //需求类别
        keywords: "", //描述
        // product_category_id: this.product_category_id, //产品类别id
        page_no: this.pageNo,
        page_size: this.pageSize,
      };
      const res = await business_publish_lists(data);
      this.businessList = res.data.lists;
      this.total = res.data.count;
    },
    async get_business_reply_lists() {
      let data = {
        publish_id: this.business_detail.id,
      };
      const res = await business_reply_lists(data);
      this.reply_lists = res.data.lists;
    },
    currentChange(e) {
      this.pageNo = e;
      this.get_lists();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.get_lists();
    },
    response_click() {
      if (this.flag == "isLogin") {
        this.dialogVisible = true;
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    async collect() {
      if (this.flag == "isLogin") {
        let data = {
          status: this.business_detail.is_collect == 0 ? 1 : 0,
          type: 4,
          dataId: this.business_detail.id,
        };
        const res = await collect(data);
        this.$message({ message: res.msg, type: "success" });
        await this.get_business_publish_detail(this.business_detail.id);
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    handleClose(done) {
      done();
    },
    async submit() {
      if (this.request_content.length == 0)
        return this.$message.warning("请先填写应答留言");
      let data = {
        needid: this.business_detail.id,
        reply: this.request_content,
      };
      console.log(this.business_detail);
      const res = await business_reply_add(data);
      if (res.code == 1) {
        this.$message({
          message: res.msg,
          type: "success",
        });
        this.request_content = "";
        this.dialogVisible = false;
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    before_add_round() {
      if (this.flag == "isLogin") {
        if (this.label_value == 1) {
          if (this.userInfo.companyid) {
            this.add_round();
          } else {
            this.$message.warning("请先认证展商");
          }
        } else {
          this.add_round();
        }
      } else {
        this.$message.warning("请先登录");
        setTimeout(function () {
          router.replace({
            path: "/login",
          });
        }, 1000);
      }
    },
    add_round() {
      this.dialog_release = !this.dialog_release;
    },
    amplify(item) {
      this.amplify_image = true;
      this.amplify_imageUrl = item;
    },
  },
};
</script>


<style scoped lang="scss">
.container {
  margin-top: 80px;
}
._search {
  margin: 40px 0 20px 0;
  .components_select {
    display: flex;

    /deep/ .el-input--suffix .el-input__inner {
      background: #f7f8fa;
      border: none;
    }

    /deep/ .el-input--prefix {
      margin: 0 15px;
    }

    /deep/ .el-input--prefix .el-input__inner {
      height: 46px;
      border-radius: 25px;
      border: 1px solid #dddddd;
    }

    /deep/ .el-button--primary {
      background: #90c31f;
      border-color: #90c31f;
      border-radius: 25px;
      width: 142px;
      font-size: 18px;
      color: #ffffff;
      //white-space: pre-wrap;
      //white-space: nowrap;
    }
    .label_box {
      display: flex;
      align-items: center;
      justify-content: left;

      .label_bottom {
        cursor: pointer;
        width: 118px;
        height: 43px;
        background: #eee;
        border-radius: 22px;
        font-weight: 400;
        font-size: 18px;
        color: #444;
        text-align: left;
        font-style: normal;
        margin-right: 15px;
        //margin-top: 15px;
        display: flex;
        justify-content: center;
        align-items: center;

        &:hover {
          color: #fff;
          background: #1d2379;
        }
      }

      .label_change {
        background: #1d2379;
        color: #ffffff;
      }
    }
  }
}

/deep/ .el-pagination {
  text-align: center;
  margin: 50px 0 100px 0;
}

//详情
.business_box {
  height: 120px;
  background: #f9fafc;
  border-radius: 30px;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin: 40px 0 30px 0;

  .top_title {
    display: flex;

    .title_picture {
      position: relative;
      margin-right: 20px;
    }

    .title_picture > img:first-child {
      width: 65px;
      height: 65px;
      border-radius: 50%;
    }

    .title_picture > img:nth-child(2) {
      width: 20px;
      height: 20px;
      position: absolute;
      bottom: 0;
      right: 0;
    }

    .title_name {
      //display: flex;
      margin-bottom: 5px;
      align-items: center;
      margin-left: 20px;
    }

    .title_name > div:nth-child(1) {
      font-weight: 500;
      font-size: 20px;
      color: #001a33;
      line-height: 28px;
      //text-align: left;
      font-style: normal;
    }

    .title_name > div:nth-child(2) {
      font-weight: 400;
      font-size: 14px;
      color: #001a33;
      line-height: 21px;
      //text-align: center;
      font-style: normal;
    }
    .title_name > div:nth-child(3) {
      font-weight: 400;
      font-size: 14px;
      color: #001a33;
      line-height: 21px;
      //text-align: center;
      font-style: normal;
    }

    .company {
      font-weight: 400;
      font-size: 15px;
      color: #ffffff;
      line-height: 21px;
      text-align: left;
      font-style: normal;
    }
  }

  .Collection {
    margin-bottom: 10px;
    width: 124px;
    height: 40px;
    background: #77a5e6;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 15px;
  }

  .Collection_change {
    background: #1d2379;
  }

  .Collection_image {
    width: 15px;
    height: 13px;
  }

  .Collection > div:nth-child(2) {
    margin: 0 10px;
  }

  .response {
    width: 124px;
    height: 40px;
    background: #90c31f;
    border-radius: 8px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    line-height: 20px;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}

.content_middle {
  padding: 30px;
  background: #f9fafc;
  border-radius: 30px;
  //margin-bottom: 80px;
}

._list_class {
  padding: 30px;
  background: #f7f8fa;
  margin-top: 30px;

  .list_item {
    width: calc((100% - 40px) / 3);
    height: 144px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    margin: 0 20px 20px 0;
    line-height: 25px;

    div:nth-child(2) {
      font-weight: 400;
      font-size: 16px;
      color: #555555;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1; /* 控制显示的行数 */
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .Personal {
      display: flex;
      margin-bottom: 15px;

      .Personal_img {
        position: relative;
        margin-right: 10px;

        img:nth-child(1) {
          width: 65px;
          height: 65px;
          border-radius: 50%;
        }

        img:nth-child(2) {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }

      .Personal_f {
        display: flex;
        align-items: center;

        .Personal_text {
          align-items: center;

          div:nth-child(1) {
            font-weight: 600;
            font-size: 18px;
            color: #000000;
            line-height: 25px;
            letter-spacing: 1px;
            text-align: left;
            font-style: normal;
          }

          div:nth-child(2) {
            margin-left: 5px;
            font-weight: 400;
            font-size: 15px;
            color: #000000;
            line-height: 25px;
            text-align: center;
            font-style: normal;
          }
        }
      }
    }
  }
}

.shImage {
  > img {
    width: 200px;
    margin: auto;
  }
}

.del_button {
  width: 220px;
  height: 52px;
  background: #e62344;
  border-radius: 9px;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 86px auto 0;
  cursor: pointer;
}
.business_label_box {
  display: flex;
}
.business_label {
  //width: 96px;
  padding: 0 14px;
  margin-right: 10px;
  height: 30px;
  background: #90c31f;
  border-radius: 3px;
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-style: normal;
  margin-bottom: 30px;
}
.Requirement_text {
  font-weight: 400;
  font-size: 15px;
  color: #001a33;
  line-height: 24px;
}
.for_image {
  margin-top: 20px;
  display: flex;
  align-items: center;
}

.item_image {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
}

/deep/ .el-image__error {
  background: #ffffff;
}

//        //弹窗

.dialog_box {
  /deep/ .el-dialog {
    top: 5%;
    width: 480px !important;
    height: 496px !important;
    background: #ffffff;
    border-radius: 20px;
    position: relative;
  }
  .dialog_line {
    width: 100%;
    border-bottom: 1px solid #f3f3f3;
  }

  .dialog_box_top {
    position: relative;
    display: flex;
    padding: 10px;
    align-items: center;
    height: 110px;
    background: #f7f8fa;
    border-radius: 8px;
    margin: 20px 0 15px 0;
  }

  .dialog_title_picture {
    position: relative;
    margin-right: 10px;
  }

  .dialog_title_picture > img:first-child {
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }

  .dialog_title_picture > img:nth-child(2) {
    width: 20px;
    height: 20px;
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .dialog_title_name {
    //display: flex;
    margin-bottom: 5px;
    align-items: center;
    margin-left: 10px;
  }

  .dialog_title_name > div:nth-child(1) {
    margin-bottom: 3px;
    font-weight: 500;
    font-size: 20px;
    color: #001a33;
    line-height: 30px;
    letter-spacing: 1px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_title_name > div:nth-child(2) {
    margin-bottom: 3px;
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: center;
    font-style: normal;
  }

  .dialog_company {
    font-weight: 400;
    font-size: 14px;
    color: #001a33;
    line-height: 21px;
    //text-align: left;
    font-style: normal;
  }
  .title_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin: 10px 0;
  }
  /deep/ .el-dialog__footer {
    position: absolute;
    display: flex;
    margin: auto;
    left: 0;
    right: 0;
    justify-content: center;
    bottom: 0;
  }
}

/deep/ .el-dialog__body {
  padding: 10px 30px 30px 30px !important;
}

.dialog_edit_img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
}

.dialog_footer {
}

.dialog_submit {
  width: 180px;
  height: 42px;
  border-radius: 9px;
  background-color: #004190;
  border-color: #004190;
}

.dialog_submit:hover {
  background-color: #004190;
  opacity: 0.9;
}

.dialog_submit:focus {
  background-color: #004190;
  opacity: 1;
}

/deep/ .el-dialog__footer {
  position: absolute;
  display: flex;
  margin: auto;
  left: 0;
  right: 0;
  justify-content: center;
  bottom: 0;
}

.add_round {
  cursor: pointer;
  position: fixed;
  right: 20px;
  top: 40%;
  width: 70px;
  height: 70px;
  background: #004190;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  div {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ffffff;
    color: #004190;
    text-align: center;
    line-height: 35px;
    font-size: 40px;
  }
}

@media only screen and (max-width: 767px) {
  .my-wrap {
    margin-top: 0.58rem;
  }
  .business_box {
    position: relative;
    height: 2.02rem;
    box-sizing: border-box;
    padding: 0.38rem 0.29rem;
    margin: 0.58rem 0 1.5rem;
    border-radius: 12px;

    .fitter_right {
      width: 100%;
      position: absolute;
      top: 2.4rem;
      left: 0;
      display: flex;
      justify-content: center;
      & > div {
        width: 3.2rem;
        height: 0.77rem;
        line-height: 0.77rem;
      }
    }
  }
  .add_round {
    width: 1.12rem;
    height: 1.12rem;

    div {
      width: 0.58rem;
      height: 0.58rem;
      font-size: 1rem;
    }
  }
  .content_middle {
    padding: 0.29rem;
    border-radius: 12px;
    .business_label_box {
      margin-bottom: 0.58rem;
    }
    .business_label {
      height: 0.46rem;
      border-radius: 0.06rem;
      font-size: 0.21rem;
      color: #e62344;
      line-height: 0.31rem;
      margin-bottom: 10px;
    }

    .Requirement_text {
      font-weight: 400;
      font-size: 0.31rem;
      color: #555555;
      line-height: 0.46rem;
      text-align: left;
      font-style: normal;
    }

    .for_image {
      margin-top: 0.38rem;
      height: 1.98rem;
      border-radius: 0.15rem;
      justify-content: space-between;

      .item_image {
        width: 1.98rem;
        height: 1.98rem;
        margin-right: 0;
      }
    }
  }
  .shImage {
    margin-top: 0.38rem;
    > img {
      width: 2.5rem;
    }
  }

  .dialog_box {
    /deep/ .el-dialog {
      width: 6.54rem !important;
      height: 7.69rem !important;
      background: #ffffff;
      border-radius: 0.38rem;
    }

    .dialog_box_top {
      padding: 0.19rem;
      height: auto;
      background: #004190;
      border-radius: 0.15rem;
    }
  }
}
</style>